module.exports = __webpack_public_path__ + "static/img/004@2x.bc70340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/004@2x.png
// module id = oJMm
// module chunks = 1